// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h3[data-v-eed8828e]{margin-top:24px;font-weight:600}.default-group-notification[data-v-eed8828e]{min-width:300px !important}`, "",{"version":3,"sources":["webpack://./src/components/AdminSettings/GeneralSettings.vue"],"names":[],"mappings":"AAEA,oBACC,eAAA,CACA,eAAA,CAGD,6CACC,0BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
